import { Router } from "express";

import { attendanceReportController } from "../controllers/attendance-report-controller";
import { courseMaterialController } from "../controllers/course-material-controller";
import { courseModuleController } from "../controllers/course-module-controller";
import { progressReportController } from "../controllers/progress-report-controller";
import { studentController } from "../controllers/student-controller";
import { authenticate, studentOnly } from "../middleware/auth-middleware";

const router = Router();

// Apply authentication and student role requirement to all routes
router.use(authenticate);
router.use(studentOnly);

/**
 * STUDENT-SPECIFIC ROUTES
 * Base path: /api/v1/student
 *
 * These routes are for students to access their own data
 */

/**
 * @route   GET /api/v1/student/profile
 * @desc    Get student's own profile
 * @access  Private (Student only)
 */
router.get("/profile", (req, res) => {
  // Redirect to profile controller with student's own ID
  (req.params as any).id = (req as any).user.userId;
  void studentController.getStudentById(req, res);
});

/**
 * @route   GET /api/v1/student/classes
 * @desc    Get student's enrolled classes
 * @access  Private (Student only)
 */
router.get("/classes", (req, res) => {
  // Redirect to student classes with student's own ID
  (req.params as any).id = (req as any).user.userId;
  void studentController.getStudentClasses(req, res);
});

/**
 * @route   GET /api/v1/student/classes/:id
 * @desc    Get a single class by ID (student must be enrolled)
 * @access  Private (Student only)
 */
router.get("/classes/:id", (req, res) => {
  void studentController.getStudentClassById(req, res);
});

/**
 * @route   GET /api/v1/student/classes/:classId/materials/:id
 * @desc    Get one course material (records access; archived excluded)
 * @access  Private (Student only)
 */
router.get("/classes/:classId/materials/:id", (req, res) =>
  courseMaterialController.getStudentCourseMaterialById(req as any, res),
);

/**
 * @route   GET /api/v1/student/classes/:classId/materials
 * @desc    List course materials for an enrolled class (archived excluded)
 * @access  Private (Student only)
 * @query   page, limit
 */
router.get("/classes/:classId/materials", (req, res) =>
  courseMaterialController.getStudentClassMaterials(req as any, res),
);

router.get("/classes/:classId/attendance/summary", (req, res) =>
  attendanceReportController.getStudentClassAttendanceSummary(req, res),
);

router.get("/courses", (req, res) =>
  courseModuleController.getStudentCourses(req, res),
);
router.get("/courses/:courseId", (req, res) =>
  courseModuleController.getStudentCourseById(req, res),
);
router.post("/courses/:courseId/enroll-request", (req, res) =>
  courseModuleController.createEnrollRequest(req, res),
);

/**
 * @route   GET /api/v1/student/statistics
 * @desc    Get student's academic statistics
 * @access  Private (Student only)
 */
router.get("/statistics", (req, res) => {
  // This would be a student-specific statistics endpoint
  // For now, redirect to profile to get academic record
  (req.params as any).id = (req as any).user.userId;
  void studentController.getStudentById(req, res);
});

/**
 * @route   GET /api/v1/student/progress-report
 * @desc    Get student's complete progress report
 * @access  Private (Student only)
 */
router.get("/progress-report", (req, res) => {
  void progressReportController.getStudentProgressReport(req, res);
});

export { router as studentSpecificRoutes };
